import React, { Component } from "react";
import { Row, Col, FormGroup } from "react-bootstrap";
import { Field, reduxForm, formValueSelector } from "redux-form";
import { connect } from "react-redux";
import {
  required,
  number,
  fieldLength9,
  maxLength17,
  accountNbrMatch,
  maxPaymentAmount,
  alphanumericAndHyphen,
  checkHyphens,
} from "../../../utils/formValidators";
import { routingNumberToolTip } from "../../../utils/toolTips";
import {
  renderField,
  renderMoneyField,
  renderRadioField,
  renderToggleField,
  renderCheckboxField,
} from "../../../utils/renderField";
import { AchInstitutionDisplay } from "../../ach-institution-display/ach-institutiton-display.component";
import * as Styled from "./styles";
import Show from "../../../utils/show.component";
import moment from "moment";

export class LoanPaymentAchFormComponent extends Component {
  constructor(props) {
    super(props);
    this.amount = "0";
    this.submitForm = this.submitForm.bind(this);
    this.onRoutingNumberChange = this.onRoutingNumberChange.bind(this);
    this.lessThanAchLimit = maxPaymentAmount(props.maxAllowedAchAmount);
  }

  onRoutingNumberChange(e) {
    if (e.target.value.length === 9) {
      this.props.searchForInstitution(e.target.value);
    } else {
      this.props.clearAchInstitution();
    }
  }

  submitForm(e) {
    if (!this.props.achInstitution.invalid) {
      this.props.submitForm(this.props.form);
    }
    this.props.clearAchInstitution();
  }

  getPrincipalOnly = () => {
    return (
      this.props.formValues !== undefined &&
      this.props.formValues.hasOwnProperty("values") &&
      this.props.formValues.values.isPrincipalOnlyAch === true
    );
  };

  componentDidMount() {
    this.props.initialize({ NameOnAccount: this.props.nameOnAccount, isPrincipalOnlyAch: false });
  }

  componentDidUpdate() {
    if (this.props.principalPayoffSwitch) {
      // Do your one-time principal only changed to payoff stuff here

      this.props.change("isPrincipalOnlyAch", false);
      this.props.togglePrincipalPayoffSwitch(false);
    }
  }
  render() {
    const {
      submitting,
      handleSubmit,
      change,
      show,
      achInstitution,
      recurringPayment,
      checkedRecurringPayment,
      showModal,
    } = this.props;
    if (this.props.formValues !== undefined && this.props.formValues.values) {
      this.amount = this.props.formValues.values.Amount ? this.props.formValues.values.Amount : "0";
    }
    const isPrincipalOnly = this.getPrincipalOnly();
    return (
      <form onSubmit={handleSubmit(this.submitForm)} className={show ? "" : "hide"}>
        <div className="row">
          <div className="col-12">
            <div className="form-group">
              <Field
                label="Name On Bank Account"
                name="NameOnAccount"
                component={renderField}
                validate={[required]}
                type="text"
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <React.Fragment>
              <div class="radio-question">
                <Field
                  name="isChecking"
                  component={renderRadioField}
                  type="radio"
                  id="checking"
                  label="Checking"
                  value="true"
                  validate={[required]}
                />{" "}
                <Field
                  name="isChecking"
                  component={renderRadioField}
                  type="radio"
                  id="savings"
                  label="Savings"
                  value="false"
                  validate={[required]}
                />{" "}
              </div>
            </React.Fragment>
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-lg-6">
            <div className="form-group">
              <Field
                component={renderField}
                label="Routing Number"
                name="RoutingNumber"
                tooltip={routingNumberToolTip}
                validate={[required, number, fieldLength9]}
                onKeyUp={(e) => this.onRoutingNumberChange(e)}
                maxLength={9}
                inputMode="numeric"
              />
              <Show condition={this.props.formValues}>
                <AchInstitutionDisplay achInstitutionState={achInstitution} showIcons={true} />
              </Show>
            </div>
          </div>
          <div className="col-12 col-lg-6">
            <div className="form-group">
              <Field
                component={renderField}
                label="Account Number"
                name="AccountNumber"
                validate={[required, alphanumericAndHyphen, checkHyphens, maxLength17]}
                type="text"
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-lg-6">
            <div className="form-group">
              <Field
                component={renderField}
                label="Re-enter Account Number"
                name="AccountNumberVerification"
                validate={[
                  required,
                  alphanumericAndHyphen,
                  checkHyphens,
                  maxLength17,
                  accountNbrMatch(this.props.formValues),
                ]}
                type="text"
              />
            </div>
          </div>
          <div className="col-12 col-lg-6">
            <div className="form-group">
              <Field
                component={renderMoneyField}
                label="Payment Amount"
                name="Amount"
                validate={[required, this.lessThanAchLimit]}
                changeFunction={change}
                inputMode="numeric"
              />
            </div>
          </div>
        </div>
        {/* hide recurring payments for now */}
        <Show condition={recurringPayment === null && false}>
          <Row>
            <Col sm={12}>
              <FormGroup>
                <Field
                  label="Turn on Automatic Payments"
                  name="EnrollInRecurring"
                  type="checkbox"
                  id="RecurringPayment"
                  showModal={() => showModal("autopay")}
                  component={renderToggleField}
                />
              </FormGroup>
            </Col>
          </Row>
        </Show>
        <Show condition={checkedRecurringPayment === true && false}>
          <Styled.RecurringPaymentToggled>
            Your first Automatic Payment will be{" "}
            {moment(this.props.dueDate).add(1, "months").format("MMMM Do, YYYY")} for $
            {this.props.regularAmountDue}
          </Styled.RecurringPaymentToggled>
        </Show>
        {/* If the amount they're paying is greater than the amount due, warn them that it will not apply towards next month */}
        <div
          className={
            !isPrincipalOnly && Number(this.amount.replace(/[$,]/g, "")) > this.props.amountDue
              ? "row show"
              : "hide"
          }
        >
          <div className="col-12">
            <div className="alert primary">
              Payment in excess of the amount due will not affect next month's payment. Your payment
              will be applied to daily accrued interest and principal.
            </div>
          </div>
        </div>

        {/* Hide principal only payment checkbox for now */}
        <Show condition={false}>
          <Show condition={isPrincipalOnly}>
            <div className="col-12 p-0">
              <div className="alert primary">
                Payments made towards the principal only will not affect the next month’s payment.
              </div>
            </div>
          </Show>

          <Show
            condition={
              new Date(this.props.nextDueDate) >= new Date() || this.props.nextDueDate == null
            }
          >
            <Field
              label="Apply Payment Amount to Principal Only"
              name="isPrincipalOnlyAch"
              type="checkbox"
              id="isPrincipalOnlyAch"
              component={renderCheckboxField}
            />
          </Show>
        </Show>
        <div className="row">
          <div className="col-12">
            <div className="form-group">
              <button disabled={submitting} className="button primary full" type="submit">
                Review Payment
              </button>
            </div>
          </div>
        </div>
      </form>
    );
  }
}

//Connect to Redux store
var LoanPaymentAchForm = reduxForm({
  form: "LoanPaymentAch",
  destroyOnUnmount: false,
  initialValues: { isPrincipalOnlyAch: false },
})(LoanPaymentAchFormComponent);

LoanPaymentAchForm = connect((state) => {
  const selector = formValueSelector("LoanPaymentAch");
  const checkedRecurringPayment = selector(state, "EnrollInRecurring");
  return {
    checkedRecurringPayment,
  };
})(LoanPaymentAchForm);

export default LoanPaymentAchForm;



// WEBPACK FOOTER //
// ./src/components/forms/loan-payment-ach/loan-payment-ach-form.component.js